import React from 'react';
import './SessionExpiredModal.css';

const SessionExpiredModal = ({ onLogin }) => {
    return (
        <div className="session-expired-overlay">
            <div className="session-expired-modal">
                <div className="session-expired-icon">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10"/>
                        <polyline points="12 6 12 12 16 14"/>
                    </svg>
                </div>
                <h2>Session Expired</h2>
                <p>Your session has ended. Please log in again to continue.</p>
                <button className="session-expired-login-btn" onClick={onLogin}>
                    Log In
                </button>
            </div>
        </div>
    );
};

export default SessionExpiredModal;
